import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-WillsTrusts',
    templateUrl: './WillsTrusts.component.html',
    styleUrls: ['./WillsTrusts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WillsTrustsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
